<template>
  <div>
    <div class="palmhotelPhone">
      <Float></Float>
      <div class="palmhotelPhoneS">
        <img src="../assets/PalmHotel.png" alt="">
        <div class="ppp">
          <p>PalmHotel is a globally leading smart hotel management system with over
            12,000 <br> hotel clients worldwide.</p>
          <p>It provides three terminals: desktop, POS handheld terminal, and mobile app. These terminals offer mobility,
            flexibility, a userfriendly interface, and
            support for various management scenarios, including offline management
            capabilities.</p>
          <p>In addition, PalmHotel supports central reservations with loyalty program
            to integration hotel booking system. Its innovative distribution tools create
            additional sales scenarios for the hotel, helping generate more revenue.</p>
          <button class="demo" @click="demo">Request a demo</button>
        </div>
      </div>
      <div class="palmhotelPhoneZ">
        <img src="../assets/palmhotel2.png" alt="">
      </div>
      <div class="palmhotelPhoneZx">
        <p class="basic">Basic Features</p>
        <div class="ppp">
          <p>Before delving into key features, any Property Management System is <br> designed to
            help business owners to organize and execute daily tasks <br> and operations. These
            include basically everything that happens in your <br> hotel, inn, or vacation rental.</p>
        </div>
        <div class="model">
          <img src="../assets/palmhotel9.png" alt="">
        </div>
      </div>
      <div class="palmhotelPhoneZint">
        <img src="../assets/palmhotel5.png" alt="">
      </div>
      <div class="intli">
        <img src="../assets/intli.png" alt="">
      </div>
      <div class="system">
        <p class="one">Intelligent Hospitality <br>
          Operation System</p>
       <div class="pppp">
        <p>PalmHotel Intelligent Hospitality Operation System, along with various terminal
          devices,<br> forms a centralized service platform that connects with multiple sales
          channels and ef- <br> ficiently manages reservations and check-ins. Through the
          utilization of diverse termi- <br> nal devices across various departments, the hotel
          achieves digital operations and <br> stream lined management</p>
       </div>
        <button class="demo" @click="demo">Request a demo</button>
      </div>
      <div class="full">
        <img src="../assets/palmhotel6.png" alt="">

      </div>
      <div class="aboutPhoneUs">
        <div>
          <img src="../assets/Palm Cube-Logo-06.png" alt="">
          <p class="Contact1">Contact US </p>
          <p>+234 9064837926 <br>lockettqin@palm-cube.com</p>
          <p class="Contact2">SHANGHAI </p>
          <p>Lumous intelligent Technology (shanghai)Co,Ltd</p>
          <p class="Contact2">LAGOS </p>
          <p>Address: ATG House, 2A, Isaac John Street,<br>GRA Ikeja, Lagos, Nigeria.</p>
        </div>
        <div class="aboutPhoneUsright">
          <div>
              <input v-model="fullName" type="text" class="input" style="width: 300px; height: 30px;"
                placeholder="Name(*)">
            </div>
            <div>
              <input v-model="mobile" type="text" class="input" style="width: 300px; height: 30px;"
                placeholder="Mobile(*)">
            </div>
            <div>
              <input v-model="email" type="text" class="input" style="width: 300px; height: 30px; "
                placeholder="Email(*)">
            </div>
            <div>
              <textarea type="text" v-model="message" class="input" style="width: 300px; height: 80px; "
                placeholder="Leave your message..." />
            </div>
            <div>
              <button class="sand" @click="addClick" style="width: 80px;height: 30px;">Send</button>
            </div>


        </div>
      </div>
    </div>
    <div class="palmhotel">
      <div class="palmhotelS">
        <div class="palmhotelSz">
          <img src="../assets/PalmHotel11.png" alt="">
          <!-- <img src="../assets/palmhotel7.png" alt=""> -->
          <p>PalmHotel is a globally leading smart hotel manageme- <br> nt system with over
            12,000 hotel clients worldwide.</p>
          <p>It provides three terminals: desktop, POS handheld <br> terminal, and mobile
            app. These terminals offer mobil- <br> ity, flexibility, a user-friendly interface, and
            support <br> for various management scenarios, including offline <br> management
            capabilities.</p>
          <p>In addition, PalmHotel supports central reservations <br> with loyalty program
            to integration hotel booking <br> system. Its innovative distribution tools create
            addi- <br> tional sales scenarios for the hotel, helping generate <br> more revenue.</p>
          <button class="demo" @click="demo">Request a demo</button>
        </div>
        <div class="palmhotelSr">
          <img src="../assets/palmhotel2.png" alt="">
        </div>
      </div>
      <div class="palmhotelZ">
        <div class="palmhotelZ-basic">
          <div>
            <p class="basic">Basic Features</p>
          </div>
          <div>
            <p>Before delving into key features, any Property Management System is <br> designed to
              help business owners to organize and execute daily tasks <br> and operations. These
              include basically everything that happens in your <br> hotel, inn, or vacation rental.</p>
          </div>
        </div>
        <div class="palmhotelZ-pic">
          <img src="../assets/palmhotel9.png" alt="">
        </div>
      </div>
      <div class="palmhotelImg">
        <img src="../assets/palmhotel5.png" alt="">
      </div>
      <div class="palmhoteltu">
        <div class="palmhoteltu1">
          <div>
            <span> SALES</span>
            <p>Multi-point sales <br>
              Easy customer relationship <br>
              management <br>
              Online contract signing</p>
          </div>
          <div>
            <span>DATA</span>
            <p> Cloud Storage <br>
              Real-time data synchronization <br>
              Multi-device synchronization</p>
          </div>
          <div>
            <span> Operation</span>
            <p> Self-check-in <br>
              Front desk management<br>
              Mobile payment gateway</p>
          </div>
          <div>
            <span> Inventory and Finance</span>
            <p>Intergate financial <br>
              management <br>
              Auto reports <br>
              Quick analysis <br>
              24/7 Online access</p>
          </div>
        </div>
      </div>

      <div class="palmhotelinit">
        <div class="palmhotelinitL">
          <p>Intelligent Hospitality <br>
            Operation System</p>
          <p>PalmHotel Intelligent Hospitality Operation System, along with various <br> terminal
            devices, forms a centralized service platform that connects <br> with multiple sales
            channels and efficiently manages reservations and <br> check-ins. Through the
            utilization of diverse terminal devices across <br> various departments, the hotel
            achieves digital operations and stream- <br> lined management</p>
          <button class="demo" @click="demo">Request a demo</button>
        </div>
        <div class="palmhotelinitR">
          <img src="../assets/palmhotel6.png" alt="">
        </div>
      </div>
      <div class="aboutD">
        <div class="aboutD-z">
          <div class="left">
            <img src="../assets/Palm Cube-Logo-06.png" alt="">
            <span class="us">Contact US</span>
            <p>+234 9064837926</p>
            <p>lockettqin@palm-cube.com</p>

            <span>SHANGHAI</span>
            <p>Lumous intelligent Technology <br>(shanghia)Co,Ltd</p>

            <span class="lagos">LAGOS</span>
            <p>Address: ATG House, 2A, Isaac John Street,<br>GRA Ikeja, Lagos, Nigeria.</p>
          </div>
          <div class="right">
            <div>
              <input v-model="fullName" type="text" class="input" style="width: 600px; height: 40px;"
                placeholder="Name(*)">
            </div>
            <div>
              <input v-model="mobile" type="text" class="input" style="width: 600px; height: 40px;"
                placeholder="Mobile(*)">
            </div>
            <div>
              <input v-model="email" type="text" class="input" style="width: 600px; height: 40px; "
                placeholder="Email(*)">
            </div>
            <div>
              <textarea type="text" v-model="message" class="input" style="width: 600px; height: 120px; "
                placeholder="Leave your message..." />
            </div>
            <div>
              <button class="sand" @click="addClick" style="width: 100px;height: 30px;">Send</button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import  Float  from "../components/Float";

export default {
  components:{
    Float
  },
  data() {
    return {
      input: '',
      textarea: '',
      fullName: '',
      mobile: '',
      email: '',
      message: '',
    }
  },
  methods: {
    demo() {
      this.$router.push('/about');
    },
    addClick() {
      // axios.post('http://192.168.31.101:31200/customer/contact/add',{}).then(res => {
      axios.post('http://unicorn-uiserver-server.palm-cube.com/customer/contact/add ', {
        fullName: this.fullName, mobile: this.mobile, email: this.email, message: this.message
      }).then(res => {
        this.fullName = '',
          this.mobile = '',
          this.email = '',
          this.message = ''
          if (res.data.errCode==0) {
          this.$router.push('/thanks');

          //   this.$notify({
          //   title: 'success',
          //   type: 'success'
          // });
            
          }
        // this.$message.success('添加成功！')
        console.log(res)
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss">
.palmhotelPhone {
  display: none;
  background: url(../assets/le.png) no-repeat;
  background-size: 100%;


  .palmhotelPhoneS {
    margin-top: 100px;
    text-align: center;

    img {
      text-align: left;
      display: block;
      margin-top: 80px;

      margin-top: 80px;

      width: 200px;
    }

    .ppp {
      width: 80%;
      margin: auto;
      font-size: 15px;
      
    }



    .demo {
      font-size: 26px;
      margin-top: 10px;
      width: 260px;
      height: 60px;
      background-color: #32c89b;
      text-align: center;
      color: #fff;
      border-radius: 30px;
      border: none;
    }
  }

  .palmhotelPhoneZ {
    margin-top: 80px;
    margin-bottom: 80px;
    text-align: center;

    img {
      width: 600px;
    }
  }

  .palmhotelPhoneZx {
    text-align: center;

    .basic {
      font-size: 50px;
      color: #444198;
      font-weight: 600;
      margin-top: 0;
    }

    .ppp {
      width:80%;
      margin: auto;
      font-size: 15px;
      // width: 800px;
      // transform: scale(0.8);
      // margin-top: 120px;
    }

    

    .model {
      margin-top: 50px;

      img {
        width: 700px;
      }
    }
  }

  .palmhotelPhoneZint {
    text-align: center;

    img {
      width: 600px;
    }
  }

  .intli {
    margin-top: 20px;

    img {
      width: 700px;
    }
  }

  .system {
    width: 100%;
    text-align: center;
    .one {
      font-size: 40px;
      font-weight: 600;
      color: #444198;
    text-align: center;

    }
   .pppp{
    width: 90%;
    margin: auto;
    text-align: center;

    font-size: 15px;
  
   }
  

    .demo {
      font-size: 26px;
      margin-top: 10px;
      width: 260px;
      height: 60px;
      background-color: #32c89b;
      text-align: center;
      color: #fff;
      border-radius: 30px;
      border: none;
    }

  }

  .full {
    margin-top: 80px;
    margin-bottom: 120px;
    text-align: center;

    img {
      width: 600px;
    }
  }

  .aboutPhoneUs {
    background-color: #F2F2F2;

    >div:nth-child(1) {
      text-align: left;

      img {
        width: 200px;
        // font-size: 40px;
      }

      .Contact1 {
        font-size: 40px;
        font-weight: 600;
        color: #444198;
      }

      .Contact2 {
        font-size: 40px;
        font-weight: 600;
        // color: #444198;
      }

      p {
        font-size: 20px;

      }
    }
  }

  .aboutPhoneUsright {
    height: 600px;
    margin-top: 20px;

    >div:nth-child(1) {
      margin: 10px 0;
    }

    >div:nth-child(2) {
      margin: 10px 0;
    }

    >div:nth-child(3) {
      margin: 10px 0;
    }

    >div:nth-child(4) {
      margin: 10px 0;
    }

    >div:nth-child(5) {
      margin: 5px 0;

      .sand {
        text-align: center;
        background-color: #444198;
        color: #fff;
        border-radius: 20px;
        border: none;
      }
    }
  }
}

.palmhotel {
  display: block;
}

.palmhotelS {
  height: 370px;

  .palmhotelSz {
    font-size: 10px;

    img {
      width: 100px;
    }
  }

  background-size: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  background: url(../assets/palmhotel13.png) no-repeat;
  background-size: 100%;
}

.palmhotelSr {
  img {
    width: 300px;
  }
}

.demo {
  font-size: 5px;
  margin-top: 10px;
  width: 60px;
  height: 15px;
  background-color: #32c89b;
  text-align: center;
  color: #fff;
  border-radius: 20px;
  border: none;
}

.palmhotelZ {
  .palmhotelZ-basic {
    display: flex;
    justify-content: center;
    align-items: center;

    margin: auto;
    width: 650px;

    // justify-content: space-evenly;
    >div:nth-child(1) {}

    >div:nth-child(2) {
      font-size: 10px;

      padding: 0 0 0 4%;
    }

    // text-align: center;
    .basic {
      font-size: 16px;
      color: #444198;
      font-weight: 600;
      margin-top: -20px;
    }

  }

  .palmhotelZ-pic {
    margin-top: 30px;
    text-align: center;

    img {
      width: 400px;
    }
  }
}

.palmhotelImg {
  margin-top: 20px;
  text-align: center;

  img {
    width: 400px;
  }
}

.palmhoteltu {
  margin-top: -60px;
  height: 490px;
  background: url(../assets/palm1.png) no-repeat;
  background-size: 100%;

  .palmhoteltu1 {
    position: relative;

    >div:nth-child(1) {
      position: absolute;
      top: 120px;
      left: 195px;

      span {
        font-size: 10px;
        font-weight: 600;
      }

      p {
        font-size: 6px;
      }
    }

    >div:nth-child(2) {
      span {
        font-size: 10px;

        font-weight: 600;
      }

      p {
        font-size: 6px;
      }

      position: absolute;
      top: 120px;
      right: 106px;
    }

    >div:nth-child(3) {
      span {
        font-size: 10px;

        font-weight: 600;
      }

      p {
        font-size: 6px;
      }

      position: absolute;
      top: 290px;
      left: 195px;
    }

    >div:nth-child(4) {
      span {
        font-size: 10px;

        font-weight: 600;
      }

      p {
        font-size: 6px;
      }

      position: absolute;
      // top: 90%;
      // right: 18%;
      top: 290px;
      right: 80px;
    }
  }

}

.palmhotelinit {
  display: flex;
  justify-content: space-evenly;
  padding: 20px 100px;

  .palmhotelinitL {
    margin-top: 25px;

    >p:nth-child(1) {
      font-weight: 600;
      font-size: 15px;
      color: #444198;
    }

    >p:nth-child(2) {
      font-size: 10px;
    }

    .demo {
      margin-top: 4px;
      width: 60px;
      height: 15px;
      background-color: #32c89b;
      text-align: center;
      color: #fff;
      border-radius: 20px;
      border: none;
    }
  }

  .palmhotelinitR {
    img {
      width: 180px;
    }
  }
}

.boomsalesX {
  background-color: #F2F2F2;
  width: 100%;
  height: 250px;


  .aboutD-z {
    padding: 20px 100px;
    display: flex;
    justify-content: space-evenly;
    // justify-content: center;
    // align-items: center;
  }


  // color:	#F5F5F5;
  .left {
    // width: 60%;
    text-align: left;

    img {
      width: 60px;
    }

    .us {
      display: block;
      color: #444198;
      font-size: 16px;
      font-weight: 600;
    }

    p {
      color: #000;
    }

    span {
      font-size: 18px;
      font-weight: 600;

    }

    .lagos {
      font-size: 18px;
      font-weight: 600;
    }
  }

  .right {
    margin-top: 20px;

    >div:nth-child(1) {
      margin: 10px 0;
    }

    >div:nth-child(2) {
      margin: 10px 0;
    }

    >div:nth-child(3) {
      margin: 10px 0;
    }

    >div:nth-child(5) {
      margin: 5px 0;

      .sand {
        text-align: center;
        background-color: #444198;
        color: #fff;
        border-radius: 20px;
        border: none;
      }
    }
  }
}

@media(max-width: 1200px) {
  .palmhotel {
    display: none;
  }
}

@media(max-width: 1200px) {
  .palmhotelPhone {
    display: block;

  }
}

</style>